import { useDispatch } from "react-redux"
import { setIsOpenDialog } from "../../store/feautures/DialogSlice";
import { toast } from "react-toastify";
import { useDeleteAgencyMutation } from "../../store/services/AgencyService";
import SmallLoader from "../main/SmallLoader";

type IProps = {
    idAzienda: number,
    dataInfo: any
}

export default function DeleteAgency({ idAzienda, dataInfo }: IProps) {

    const dispatch = useDispatch();
    const [deleteAgency, deleteresult] = useDeleteAgencyMutation();

    const handleClose = () => {
        dispatch(setIsOpenDialog(true));
    }

    const handleDelete  = async () => {
        const result: any = await deleteAgency(idAzienda);
        if ('error' in result) {
            toast.error(`Azienda non eliminata! Errore: ${result?.error?.data?.detail}`)
        } else {
            toast.success(`Azienda eliminata! `);
            dispatch(setIsOpenDialog(true));
        }
    }

    return (
        <div className="p-10 min-h-[300px] flex flex-col justify-between relative">
            {deleteresult.isLoading && <SmallLoader />}
            <p>Sei sicuro di voler eliminale l'azienda {dataInfo.nome} ?</p>
            <div className="mt-4 grid grid-cols-2 space-x-4">
                <button onClick={handleClose} type="button" className="h-10 border !text-[#064e3b] !border-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Annulla
                </button>
                <button onClick={handleDelete} type="button" className="h-10 bg-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Elimina
                </button>
            </div>
        </div>
    )
}